export default __webpack_public_path__ + "static/media/door_white_small.a02f97c0.png";